import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 31 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m15.438 26.25-3.22.906a.87.87 0 0 1-.796-.14.83.83 0 0 1-.36-.703q0-.376.094-.61a.86.86 0 0 1 .25-.36l2.156-1.593v-6.875L4.47 19.563q-.594.156-1.063-.188t-.469-.969q0-.468.157-.781.156-.312.437-.469l10.031-5.906V4.375q0-.781.547-1.328a1.8 1.8 0 0 1 1.329-.547q.78 0 1.328.547.547.546.547 1.328v6.875l10.03 5.906q.282.156.438.469t.157.781q0 .625-.47.969-.468.345-1.062.188l-9.093-2.688v6.875l2.156 1.594a.86.86 0 0 1 .25.36q.093.233.093.608 0 .438-.359.704a.87.87 0 0 1-.797.14z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }